export default __webpack_public_path__ + "static/media/aboutJs1.171c0c86.jpg";